import profile_icon from 'src/assets/profile_icon.png';
import letter_w from 'src/assets/letter_w.png';

import React, { useState } from 'react'
import { useContext } from 'react'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import {
  LeaderboardBody,
  LeaderboardPageContainer,
  LeaderboardPrimaryHeader,
  LeaderboardSecondaryHeader,
  LeaderboardSecondaryHeaderItems,
} from './LeaderboardPageStyles'
import { DisplayFlex } from '../ConsumerProfilePage/ProfileLeftPannelStyle'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { useNavigate } from 'react-router-dom'
import Leaderboard from './Leaderboard'
import YourStats from './YourStats'
import YourBadges from './YourBadges'
import { useEffect } from 'react'

export default function LeaderboardPageWebview() {
  const navigate = useNavigate()
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [activeHeading, setActiveHeading] = useState('your_stats')
  const [profileData, setProfileData] = useState()
  const [setupData, setSetupData] = useState()

  // Define a function to call the Android interface's methods
  const callAndroidInterface = () => {
    if (window.Android && typeof window.Android.getUserToken === 'function') {
      console.log('user token is ' + window.Android.getUserToken())
      localStorage.setItem('token', window.Android.getUserToken())
    }
    if (window.Android && typeof window.Android.getUserProfile === 'function') {
      console.log('after parsing, profile data is ')
      console.log(JSON.parse(window.Android.getUserProfile()))
      setProfileData(JSON.parse(window.Android.getUserProfile()))
    }
    if (window.Android && typeof window.Android.getSetupData === 'function') {
      console.log('after parsing, setup data is ')
      console.log(JSON.parse(window.Android.getSetupData()))
      setSetupData(JSON.parse(window.Android.getSetupData()))
    }
  }

  // Use useEffect to call Android interface methods when page loads
  useEffect(() => {
    callAndroidInterface()
  }, [])

  return (
    <LeaderboardPageContainer>
      <LeaderboardPrimaryHeader isMobile={unSecureSetupData?.clientType === 'mobileBrowser'}>
        <DisplayFlex style={{ cursor: 'pointer' }} onClick={() => window.Android.nativeOnBack()}>
          <ArrowBackIosIcon sx={{ fontSize: 15, color: 'white' }} />
        </DisplayFlex>
        {/* <LeaderboardProfileImage src={profilePicId ? (isValidHttpUrl(profilePicId) ? profilePicId : mediaURL + profilePicId) : profile_icon} /> */}
      </LeaderboardPrimaryHeader>

      <LeaderboardSecondaryHeader isMobile={unSecureSetupData?.clientType === 'mobileBrowser'}>
        <LeaderboardSecondaryHeaderItems
          onClick={() => setActiveHeading('your_stats')}
          isActive={activeHeading === 'your_stats'}
        >
          Your Stats
        </LeaderboardSecondaryHeaderItems>
        <LeaderboardSecondaryHeaderItems
          onClick={() => setActiveHeading('your_badges')}
          isActive={activeHeading === 'your_badges'}
        >
          Your Badges
        </LeaderboardSecondaryHeaderItems>
        <LeaderboardSecondaryHeaderItems
          onClick={() => setActiveHeading('leaderboard')}
          isActive={activeHeading === 'leaderboard'}
        >
          Leaderboard
        </LeaderboardSecondaryHeaderItems>
        {/* <LeaderboardSecondaryHeaderItems onClick={() => setActiveHeading('words_leaderboard')} isActive={activeHeading === 'words_leaderboard'}>Words<LeaderboardSectionIcon src={letter_w} /></LeaderboardSecondaryHeaderItems> */}
      </LeaderboardSecondaryHeader>

      <LeaderboardBody isMobile={unSecureSetupData?.clientType === 'mobileBrowser'}>
        {activeHeading === 'your_stats' && <YourStats />}
        {activeHeading === 'your_badges' && <YourBadges />}
        {activeHeading === 'leaderboard' && (
          <Leaderboard profileData={profileData} setupData={setupData} />
        )}
        {/* {activeHeading === "points_leaderboard" && <Leaderboard primaryCriteria="points" />} */}
      </LeaderboardBody>
    </LeaderboardPageContainer>
  )
}
